import React, { Component } from 'react';
import './App.css';
import Target from './components/target';
import TestButton from './components/testbutton';
import LivesCounter from './components/livescoutner';

class App extends Component {
  state = {
    open: true,
    targetstyle: {
      left: "10%",
      top: '60%'
    },
    targets: [],
    lives: 3,
    score: 0,
    gameover: false,
    gamerunning: false,
   }

   targetCount = 0;
   failCount = 0;
   successtargets = {};
   timeout = 1500;
   timeoutID = null;
   exauhstedID = [];
   audio = new Audio("/hacker.mp3");

  getRandomLoc = (min, max) => {
    let loc = []
      min = Math.ceil(min);
      max = Math.floor(max);
      loc[1] = Math.floor(Math.random() * (max - min + 1) + min);
      loc[2] = Math.floor(Math.random() * (max - min + 1) + min);
    return {left: loc[1]+"%", top: loc[2]+"%"} //The maximum is inclusive and the minimum is inclusive
  }

  targetExpire  = (target) => {
    if (!this.state.gamerunning) {return;}
    if (this.state.gameover) {return;}
    if (!this.successtargets[target.id]) {
      this.failCount =  this.failCount + 1
      let lives = this.state.lives
      let gameover = this.state.gameover
      lives = lives - 1
      this.setState({ lives });
      if (lives == 0) {
        gameover = true
        this.setState({ gameover });
        setTimeout(() => {
          this.resetGame()
        }, 5000);
      }
    }
    //let targets = this.state.targets
    //const index = targets.indexOf(target);
    //console.log(index)
    //if (index === -1) {return;}
    //console.log("index is ", index)
    //targets.splice(index, 1);
    //if (targets.length < 1 ) {
    //  this.setState({ targets });
    //}
    //console.log("targets ", this.state.targets)
  }

  HandleTargetClick = (target) => {
    this.successtargets[target.id] = true;
    let targets = this.state.targets
    const index = targets.indexOf(target);
    if (index === -1) {return;}
    console.log("index is ", index)
    targets.splice(index, 1);
    this.setState({ targets });
    let score = this.state.score
    score = score + 1
    this.setState({ score });
  }

  addTarget = () => {
    if (this.state.gameover) {return;}
    this.targetCount = this.targetCount + 1
    let target = {id: this.targetCount, loc: this.getRandomLoc(20,80)}
    let targets = this.state.targets
    targets.push(target)
    this.setState({ targets });
    console.log(targets)
    this.timeoutID = setTimeout(() => {
      this.addTarget()
    }, (this.timeout));
    if (this.timeout > 500) {
      this.timeout = this.timeout - this.targetCount * 5
      if (this.timeout < 500)  {
        this.timeout = 500
      }
    }
  }

  startGame = () => {
    let fullscreen = document.querySelector("html");
    if (!document.fullscreenElement) {
      fullscreen?.requestFullscreen();
    }
    this.audio.play()
    this.audio.volume = 0.02;
    let gamerunning = this.state.gamerunning
    gamerunning = true
    this.setState({ gamerunning });
    this.addTarget()
  }

  resetGame = () => {
    clearTimeout(this.timeoutID)
    Object.keys(this.exauhstedID).forEach(key => {
      console.log(this.exauhstedID[key])
      clearTimeout(this.exauhstedID[key])
    });
    setTimeout(() => {
      this.setState({
        targetstyle: {
          left: "10%",
          top: '60%'
        },
        targets: [],
        lives: 3,
        score: 0,
        gameover: false,
        gamerunning: false,
       });
       this.targetCount = 0;
       this.failCount = 0;
       this.successtargets = {};
       this.timeout = 1500;
       this.timeoutID = null;
       this.exauhstedID = [];
       this.audio.pause();
       this.audio.currentTime = 0;
    }, 500);
  }

  addExauhstedID = (id) => {
    this.exauhstedID[id] = id
  }

  openGame = () => {
    if (this.state.open) {
      return !this.state.gameover ? (
        <div>
          <div className="container">
            <div className='box'>
            {!this.state.gamerunning && <TestButton onAddNewTarget = {this.startGame}></TestButton>}
            </div>
            <span className="score">{this.state.score + "%"}</span>
            <LivesCounter lives={this.state.lives}></LivesCounter>
            {
            Object.keys(this.state.targets).map((keyName, i) => (
                <Target onAddId={this.addExauhstedID} usedIDs={this.exauhstedID} onTargetClick={this.HandleTargetClick} ontargetExpire={this.targetExpire} id={this.state.targets[keyName].id} key={this.state.targets[keyName].id} delay="3000" target={this.state.targets[keyName]}></Target>
            ))
            }
          </div>
      </div>
      ) : (
        <div className="container">
            <div className='box'>
            <span className='gameovertext'>GAME OVER</span>
            {/*<div onClick={() => this.resetGame()} className='resetButton'>RESTART</div>*/}
            </div>
            <span className="score">{this.state.score + "%"}</span>
            <LivesCounter lives={this.state.lives}></LivesCounter>
        </div>
      );
    }
  }

  render() { 
    return (<React.Fragment>{this.openGame()}</React.Fragment>);
  }
}

export default App;
